import { defa } from 'defa-object';

import Form     from 'scripts/poppet/form';
import template from 'templates/settingsAutomotiveForm.jst.html';

const selectors = {
	inputType      : '[data-input=automotive-type]',
	inputBrand     : '[data-input=automotive-brand]',
	inputModel     : '[data-input=automotive-model]',
	inputYear      : '[data-input=automotive-year]',
	inputRegNum    : '[data-input=automotive-registration-number]',
	inputChassisNum: '[data-input=automotive-chassis-number]',
	inputColor     : '[data-input=automotive-color]',
};

/**
 * defa.views.SettingsAutomotiveForm
 * The basic view for editing a SettingsAutomotive.
 * @version 1.2.0
 */
const SettingsAutomotiveForm = Form.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template: template,
	
	ui: {
		type              : selectors.inputType,
		brand             : selectors.inputBrand,
		model             : selectors.inputModel,
		registrationYear  : selectors.inputYear,
		registrationNumber: selectors.inputRegNum,
		chassisNumber     : selectors.inputChassisNum,
		color             : selectors.inputColor,
	},
	
	
	templateContext: function () {
		return {
			context                 : this.options.context,
			hasUnselectedVehicleType: this._isClaimFlow() || this._isBrokenSettings(), // isClaimFlow ||
																					   // isBrokenSettings
			insuranceBlock          : this._hasInsurance() && ( this.options.context !== 'install' ),
		};
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
	 * Triggers when the view has rendered.
	 * @void
	 */
	onRender: function () {
		this.createSettingsAutomotiveTypesHTML();
	},
	
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Checks if the Unit has a subscription with insurance.
	 * @void
	 */
	_hasInsurance: function () {
		return ( this.options.unit.get( 'transientInsuranceCompany' ) );
	},
	
	/**
	 * Checks if this view should have init validation.
	 * @return {bool}  True if this view should have init validation, false if not.
	 */
	hasInitValidation: function () {
		return ( 'install' === this.options.context );
	},
	
	/**
	 * Checks if this is part of the claim flow.
	 * @return {bool}  True if part of the claim flow, false if not.
	 */
	_isClaimFlow: function () {
		return this.options.vehicleTypes;
	},
	
	/**
	 * Checks if this view's settingsAutomotive model is corrupted.
	 * @return {bool}  True if broken, false if not.
	 */
	_isBrokenSettings: function () {
		return !this.model.get( 'type' );
	},
	
	/**
	 * Creates and attaches the html for the vehicletypes available.
	 * @void
	 */
	createSettingsAutomotiveTypesHTML: function () {
		
		let self  = this,
			html5 = '';
		
		if ( this._isBrokenSettings() && !this._isClaimFlow() ) {
			
			_.each( defa.vars.vehicleTypes, function ( type ) {
				html5 += '<option value="%s1">%s3</option>'
					.replace( '%s1', type.id )
					.replace( '%s3', type.type );
			} );
			
		} else {
			
			if ( this._isClaimFlow() ) {
				
				_.each( defa.vars.vehicleTypes, function ( type ) {
					
					if ( _.indexOf( self.options.vehicleTypes, type.id ) !== -1 ) {
						
						let vehicleType = parseInt( self.model.get( 'type' ), 10 ),
							optionType  = parseInt( type.id, 10 ),
							selected    = ( vehicleType === optionType )
										  ? ' selected'
										  : '';
						
						html5 += '<option value="%s1"%s2>%s3</option>'
							.replace( '%s1', type.id )
							.replace( '%s2', selected )
							.replace( '%s3', type.type );
					}
				} );
				
			} else if ( !this._isClaimFlow() ) {
				
				let type = _.find( defa.vars.vehicleTypes, function ( t ) {
					return t.id === parseInt( self.model.get( 'type' ), 10 );
				} );
				
				html5 += '<option value="%1s" selected>%2s</option>'
					.replace( '%1s', type.id )
					.replace( '%2s', type.type );
				
			}
			
		}
		
		// is claimFlow
		
		
		this.ui.type.append( html5 );
	},
	
	/**
	 * Submits the form.
	 * @void
	 */
	submit: function () {
		
		let form = {
			type              : this.ui.type.val().trim(),
			brand             : this.ui.brand.val().trim(),
			model             : this.ui.model.val().trim(),
			registrationYear  : this.ui.registrationYear.val().trim(),
			registrationNumber: this.ui.registrationNumber.val().trim(),
			chassisNumber     : this.ui.chassisNumber.val().trim(),
			color             : this.ui.color.val().trim(),
		};
		
		// type must be null not false for the backend for some reason.
		form.type = ( !this.ui.type.val().trim() )
			? null
			: this.ui.type.val().trim();
		
		this.model.save( form );
	},
	
} );

export default SettingsAutomotiveForm;